import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import MuiPagination from '@mui/material/Pagination';
import { Paper, MenuItem, Select, Typography, Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useGridStyles = makeStyles(theme => ({
  container: {
    justifyContent: 'center',
  },
  perPage: {
    alignItems: 'center',
    display: 'flex',
  },
  label: {
    marginRight: theme.spacing(2),
  },
  margin: {
    marginTop: theme.spacing(3),
    marginBottom: 0,
  },
}));

const usePaginationStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  ul: {
    justifyContent: 'center',
  },
}));

const Pagination = ({
  onChange,
  page,
  count,
  background,
  rowsPerPageOptions,
  onChangeRowsPerPage,
  rowsPerPage,
  showSelectPerPage,
}) => {
  const { t } = useTranslation();
  const paginationClasses = usePaginationStyles();
  const gridClasses = useGridStyles();

  const pagination = (
    <Grid
      container
      spacing={5}
      className={clsx(gridClasses.container, {
        [gridClasses.margin]: background,
      })}
    >
      {showSelectPerPage ? (
        <Grid item className={gridClasses.perPage}>
          <Typography variant="caption" className={gridClasses.label}>
            {t('Rows per page')}:
          </Typography>
          <Select variant="standard" onChange={onChangeRowsPerPage} value={rowsPerPage}>
            {rowsPerPageOptions.map(option => (
              <MenuItem key={option} value={option}>
                <Typography variant="body2">{option}</Typography>
              </MenuItem>
            ))}
          </Select>
        </Grid>
      ) : null}
      <Grid item>
        <MuiPagination
          shape="rounded"
          count={count}
          page={page}
          onChange={onChange}
          classes={paginationClasses}
        />
      </Grid>
    </Grid>
  );
  return background ? <Paper>{pagination}</Paper> : pagination;
};

Pagination.defaultProps = {
  background: false,
  rowsPerPageOptions: [10, 25, 50, 100],
  onChangeRowsPerPage: undefined,
  showSelectPerPage: false,
  rowsPerPage: undefined,
};

Pagination.propTypes = {
  onChange: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number,
  background: PropTypes.bool,
  onChangeRowsPerPage: PropTypes.func,
  rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
  showSelectPerPage: PropTypes.bool,
};

export default Pagination;
